import { createAction } from '@reduxjs/toolkit';

import { Notification } from '../types';

export const addNotification = createAction<Notification>('ADD_NOTIFICATION');

export const removeNotification = createAction<string>('REMOVE_NOTIFICATION');
